module.exports = __webpack_public_path__ + "static/media/pl.f7adaa94.svg";